import React from "react";
import {AppBar, Container, Grid, Link, Stack, Typography} from "@mui/material";
import Copyright from "../../Copyright/Copyright";
import {useTranslation} from "react-i18next";
import {ASSOCIATES, LAST_UPDATE} from "../../../constants";
import TwitterIcon from "@mui/icons-material/Twitter";

function Footer() {
    const {t} = useTranslation('common');

    return (
        <AppBar
            sx={{
                padding: theme => theme.spacing(3, 2, 2, 2),
                position: 'relative',
                top: 'auto',
                bottom: 0,
                bgcolor: theme => theme.palette.appBar.dark,
                borderTop: theme => theme.palette.mode === "light"
                    ? `solid 4px ${theme.palette.appBar.main}`
                    : `solid 4px ${theme.palette.primary.dark}`,
            }}
            elevation={0}
        >
            <Container maxWidth="xl">
                <Grid container spacing={5}>
                    <Grid item xs={12} md={4} xl={4} display="flex" flexDirection="column" alignItems="center"
                          justifyContent="space-evenly">
                        <Typography variant="h6" fontWeight="bold" mb={3}>
                            {t("main.components.footer.partners")}
                        </Typography>
                        <Grid
                            container
                            alignItems="center"
                            justifyContent="space-evenly"
                            flexDirection="row"
                            spacing={2}
                            maxWidth="300px">
                            {
                                ASSOCIATES.map((associate) => (
                                    <Grid key={associate.alt} item>
                                        <Link color="inherit" href={associate.link} target="_blank" rel="noopener">
                                            <img src={associate.src} width="60px" alt={associate.alt}/>
                                        </Link>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={4} xl={4} display="flex" flexDirection="column" alignItems="center">
                        <Typography variant="h6"
                                    fontWeight="bold">{t("main.components.footer.about.title")}</Typography>
                        <ul>
                            <li><Link underline="none" color="inherit" href="/history">
                                {t("main.components.footer.about.history")}
                            </Link></li>
                            <li><Link underline="none" color="inherit" href="https://www.litislab.fr/litis"
                                      target="_blank" rel="noopener">
                                {t("main.components.footer.about.lab")}
                            </Link></li>
                            <li><Link underline="none" color="inherit" href="https://www.litislab.fr/equipe/app"
                                      target="_blank" rel="noopener">
                                {t("main.components.footer.about.team")}
                            </Link></li>
                            <li><Link underline="none" color="inherit" href="https://www.litislab.fr/page/contact"
                                      target="_blank" rel="noopener">
                                {t("main.components.footer.about.contact")}
                            </Link></li>
                        </ul>
                    </Grid>
                    <Grid item xs={12} md={4} xl={4} display="flex" flexDirection="column" alignItems="center">
                        <Typography variant="h6" fontWeight="bold">{t("main.components.footer.follow")}</Typography>
                        <Link underline="none" color="inherit" href="https://twitter.com/litislab"
                              target="_blank" rel="noopener">
                            <TwitterIcon fontSize="large"/>
                        </Link>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} xl={12}>
                    <Stack pt={5} direction="row" alignItems="start" justifyContent="space-between">
                        <Copyright/>
                        <Typography fontSize="small" textAlign="end">
                            {`${t("main.components.footer.latest")}: ${LAST_UPDATE}`}
                        </Typography>
                    </Stack>
                </Grid>
            </Container>
        </AppBar>
    );
}

export default Footer;